import { gql } from "@apollo/client";

export const CREATE_INSTITUTE_OR_UNIVERSITY = gql`
  mutation CreateInstituteOrUniversity($input: InstituteOrUniversityInput) {
    createInstituteOrUniversity(input: $input) {
      isSuccess
      message {
        messageKh
        messageEn
      }
    }
  }
`;

export const GET_INSTITUTE_OR_UNIVERSITY_WITH_PAGINATION = gql`
  query GetInstituteOrUniversityPagination(
    $page: Int
    $limit: Int
    $keyword: String
    $pagination: Boolean
  ) {
    getInstituteOrUniversityPagination(
      page: $page
      limit: $limit
      keyword: $keyword
      pagination: $pagination
    ) {
      data {
        _id
        nameKh
        nameEng
      }
      paginator {
        slNo
        prev
        next
        perPage
        totalPosts
        totalPages
        currentPage
        hasPrevPage
        hasNextPage
        totalDocs
      }
    }
  }
`;
 
export const UPDATE_INSTITUTE_OR_UNIVERSITY = gql`
  mutation UpdateInstituteOrUniversity(
    $id: ID!
    $input: InstituteOrUniversityInput
  ) { 
    updateInstituteOrUniversity(_id: $id, input: $input) {
      isSuccess
      message {
        messageKh
        messageEn
      }
    }
  }
`;

export const DELETE_INSTITUTE_OR_UNIVERSITY = gql`
  mutation DeleteInstituteOrUniversity($id: ID!) {
    deleteInstituteOrUniversity(_id: $id) {
      isSuccess
      message {
        messageKh
        messageEn
      }
    }
  }
`;
